// PBR — turns bare email addresses inside [data-pbr-linkify] containers into
// mailto: links. The Customizer's rich text editor makes typing a mailto link
// fiddly, so merchants can just type the address and it links itself. Text
// that already sits inside an <a> is left alone.

const EMAIL = /[\w.+-]+@[\w-]+(?:\.[\w-]+)+/g;
const HAS_EMAIL = /[\w.+-]+@[\w-]+(?:\.[\w-]+)+/;

function linkify(root) {
  if (root.dataset.pbrLinkified) return;
  root.dataset.pbrLinkified = 'true';

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      if (!HAS_EMAIL.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
      if (node.parentElement?.closest('a, script, style')) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    },
  });

  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);

  for (const node of nodes) {
    const text = node.nodeValue;
    const fragment = document.createDocumentFragment();
    let last = 0;

    for (const match of text.matchAll(EMAIL)) {
      fragment.appendChild(document.createTextNode(text.slice(last, match.index)));
      const link = document.createElement('a');
      link.href = `mailto:${match[0]}`;
      link.textContent = match[0];
      fragment.appendChild(link);
      last = match.index + match[0].length;
    }

    fragment.appendChild(document.createTextNode(text.slice(last)));
    node.replaceWith(fragment);
  }
}

function run(scope = document) {
  scope.querySelectorAll('[data-pbr-linkify]').forEach(linkify);
}

run();

// Theme editor re-renders sections in place — link the fresh markup too.
document.addEventListener('shopify:section:load', (event) => run(event.target));
